import { Component, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { navItems } from '../../_nav';
import { State } from '../../store/main';
import { State as AuthState } from '../../store/auth/main';
import { State as UserState } from '../../store/users/main';
import { User } from '../../store/users/models';
import { select, Store } from '@ngrx/store';
import { Logout } from '../../store/auth/actions';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'base-layout',
  styleUrls: ['./base-layout.component.scss'],
  templateUrl: './base-layout.component.html',
  standalone: false,
})
export class BaseLayoutComponent implements OnDestroy {
  public navItems = navItems;
  public sidebarVisible = true;
  public sidebarUnfoldable = false;
  public users$ = new BehaviorSubject<User[]>([]);
  public user$ = new BehaviorSubject<User | undefined>(undefined);
  public fullName: any = undefined;
  public currentYear: number = new Date().getFullYear();

  constructor(private store: Store<State>) {
    this.store
      .pipe(select('users'))
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (usersState: UserState) => {
          this.user$.next(usersState.selectedUser);
        },
      });

    this.store
      .pipe(select('auth'))
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (authState: AuthState) => {
          this.fullName = authState.fullName;
        },
      });
  }

  ngOnDestroy(): void {}

  public async logout() {
    this.store.dispatch(new Logout());
  }

  public handleSidebarVisibilityChange(isVisible: boolean): void {
    this.sidebarVisible = isVisible;
  }

  public toggleSidebarUnfoldable(): void {
    this.sidebarUnfoldable = !this.sidebarUnfoldable;
  }
}
